import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer className="py-4 bg-footer mt-auto">
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between small">
            <div className="text-muted-1">
              © 2024 <b>JC Creations</b>.
            </div>
            {/* <div className="text-muted-1">© 2024 <b>JC Creations</b>. by <a href="https://beyondwave.in">BeyondWave Technologies</a></div> */}
            <div className="footer-links">
              <a
                target="blank"
                href="https://jc-creations.in/privacy-policy"
              >
                Privacy Policy
              </a>
              <a
                target="blank"
                href="https://jc-creations.in/terms-and-conditions"
              >
                Terms &amp; Conditions
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/footer/index.js